import styled from 'styled-components';
import { ReactElement } from 'react';

import { Address } from '@dreryk/address-common-api';
import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { addressFormatter } from '@dreryk/react-common';
import { appendTestableComponentAttributes, TestId, useSelectContext } from '@dreryk/react-components';

import { FacilityDescription } from '../../FacilityDescription';

const StyledHealthcareProviderLocationSelectItem = styled.li`
   padding: 10px 12px;
   background-color: ${(props) => props.theme.backgroundBody};
   cursor: pointer;
   &:not(:last-child) {
      border-bottom: 1px solid ${(props) => props.theme.borderLight};
   }
`;

type HealthcareProviderLocationSelectItemProps = {
   readonly item: HealthcareProviderLocation;
   readonly facilityName: string;
   readonly facilityAddress: Address;
   readonly testId: TestId;
};
export const HealthcareProviderLocationSelectCellItem = (
   props: HealthcareProviderLocationSelectItemProps
): ReactElement => {
   const { handleSelect } = useSelectContext<HealthcareProviderLocation>();
   return (
      <StyledHealthcareProviderLocationSelectItem
         onClick={() => handleSelect(props.item)}
         {...appendTestableComponentAttributes('SelectCellItem', props.testId)}
      >
         <FacilityDescription name={props.facilityName} address={addressFormatter(props.facilityAddress)} />
      </StyledHealthcareProviderLocationSelectItem>
   );
};
